import React from 'react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';

import './style.styl';

import { Button } from '@material-ui/core';

@inject('vm')
@observer
class Action extends React.Component {
  static defaultProps = {
    icon: null,
    label: '',
    onClick: () => {}
  };

  render() {
    let { label, vm } = this.props;

    return (
      <Button
        variant={'outlined'}
        className="action-base"
        small={true}
        disabled={vm.loading}
        onClick={this.onClick}
      >
        {label}
      </Button>
    );
  }

  @action.bound
  onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.onClick();
  }
}

export default Action;
